import React from "react";
import { AdBlock } from "../../atoms/AdBlock/AdBlock";
import { Box } from "../../atoms/Layout/Box/Box";
import { GridCell } from "../../atoms/Layout/GridCell/GridCell";
import { GridRow } from "../../atoms/Layout/GridRow/GridRow";
import {
  LandscapeQuery,
  MobileQuery,
  PortraitQuery,
} from "../../atoms/Layout/Responsive";
import { Game } from "../../models/Game";
import { GameTile } from "../../molecules/Tiles/GameTile";
import styles from "./SearchGamesList.css";
import classNames from "classnames";

type SearchGamesListProps = {
  games: Game[];
};

export class SearchGamesList extends React.PureComponent<SearchGamesListProps> {
  getGamesList(from: number, to?: number): JSX.Element[] {
    const { games } = this.props;

    return games.slice(from, to).map((game, ind) => (
      <Cell key={from + ind} size={[4, 6]}>
        <GameTile resizable={true} hardLink={true} game={game} />
      </Cell>
    ));
  }

  render() {
    return (
      <Row paddingB="md" wrap="wrap">
        <LandscapeQuery>{this.getGamesList(0, 3)}</LandscapeQuery>

        <PortraitQuery>{this.getGamesList(0, 2)}</PortraitQuery>

        <MobileQuery>
          <AdCell key={"ads"} size={12}>
            <Box align="center" justify="center">
              <AdBlock id="adslot1004" size="300x250" />
            </Box>
          </AdCell>
        </MobileQuery>

        <LandscapeQuery>{this.getGamesList(3)}</LandscapeQuery>

        <PortraitQuery>{this.getGamesList(2)}</PortraitQuery>
      </Row>
    );
  }
}

const Row = (props: any) => <GridRow className={styles.row} {...props} />;
const Cell = ({ className, ...props }: any) => (
  <GridCell className={classNames(styles.cell, className)} {...props} />
);
const AdCell = (props: any) => <Cell className={styles.adCell} {...props} />;
